import { request } from "utils/api";
import { Club } from "./clubs";
import { ContactData } from "./user";

// check-in from GET /check-ins/active
export interface CheckIn {
    club: Club,
    endDate: string,
    id: string,
    startDate: string,
}

// check-in info from GET /check-ins/clubs/single
export interface CheckInInfo {
    activeCheckInId?: string,
    club: Club,
    userIsCheckedInUntilDate?: string,
}

// contact data with consent
export interface ContactDataWithConsent extends ContactData {
    consentDate: string,
    storePermanently: boolean,
}

// retrieve active check-ins (GET /check-ins/active)
export const getCheckInsActive = (data: {
    guestIdentifier: string,
}) => request<CheckIn[]>({
    data,
    endpoint: "/check-ins/active",
    method: "get",
});

// create check-in at a club (POST /check-ins)
export const postCheckIns = (data: {
    clientLatitude: number,
    clientLongitude: number,
    clubId: string,
    companionsContactData?: ContactData[],
    contactData: ContactDataWithConsent,
    durationMins: number,
    guestIdentifier: string,
}) => request<CheckIn>({
    data,
    endpoint: "/check-ins",
    method: "post",
});

// end check-in manually (PATCH /check-ins/end)
export const patchCheckInsEnd = (data: {
    checkInId: string,
    guestIdentifier: string,
}) => request<CheckIn>({
    data,
    endpoint: "/check-ins/end",
    method: "patch",
});

// retrieve single club check-in
export const getCheckInsSingleClub = (data: {
    clubId: string,
    guestIdentifier: string,
}) => request<CheckInInfo>({
    data,
    endpoint: "/check-ins/clubs/single",
    method: "get",
});
